import * as React from 'react'

import { WidgetFooterProp } from './interface'
import { Footer } from './style'

const WidgetFooter: React.FC<WidgetFooterProp> = ({ children, ...rest }) => <Footer {...rest}>{children}</Footer>

export default WidgetFooter
